<template>
  <div>
    <h4 class="font-weight-bold">RELATED PARTIES</h4>
    <button class="mb-2 btn btn-success btn-sm" data-toggle="modal" @click="resetForm" data-target="#relatedPartyModal">
      <font-awesome-icon icon="plus" class="force-white-all"/>
      ADD PARTY
    </button>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-12 col-xl-3" v-for="(party,index) in relatedPartyLists">
          <div class="card mb-3" style="height: 450px;">
            <div class="card-body" style="overflow: auto;">
              <div class="row">
                <div class="col-8">
                  <span class="font-weight-bold text-uppercase h6">{{ party.party_name ? party.party_name : '' }}</span>
                  <span class="text-danger font-weight-bold h6"> ({{party.vessels.length}})</span>
                </div>
                <div class="col-4 pr-1 text-right">
                  <button class="btn-xs btn btn-warning mr-2" title="EDIT RELATED PARTY"
                          data-target="#relatedPartyUpdateModal"
                          @click="setForm(party)"
                          data-toggle="modal">
                    <font-awesome-icon icon="pen" class="force-white-all"/>
                  </button>
                  <button class="btn-xs btn btn-danger mr-2" title="DELETE RELATED PARTY"
                          @click="deleteRelatedParty(party.id)">
                    <font-awesome-icon icon="trash" class="force-white-all"/>
                  </button>
                </div>
              </div>
              <hr>
              <div class="row mb-2">
                <div class="col-12 mb-2">
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <button :class="[party.active_tab === 'vessels' ? 'active' : '']" class="main-tabs nav-link text-uppercase font-weight-bold" data-toggle="pill" type="button" role="tab" @click="party.active_tab = 'vessels'">Vessels</button>
                      <button :class="[party.active_tab === 'emails' ? 'active' : '']" class="main-tabs nav-link text-uppercase font-weight-bold" data-toggle="pill" type="button" role="tab" @click="party.active_tab = 'emails'">Emails</button>
                    </div>
                  </nav>
                </div>
              </div>
              <template v-if="party.active_tab === 'vessels'">
                <div class="row" v-for="vessel in party.vessels" >
                  <div class="col-12">
                    <span class="font-weight-bold">{{ vessel.vessel_name ? vessel.vessel_name : '' }}</span>
                  </div>
                </div>
              </template>
              <template v-if="party.active_tab === 'emails'">
                <div class="row" v-for="email in party.emails" >
                  <div class="col-12">
                    <span class="font-weight-bold">{{ email.email_address ? email.email_address : '' }}</span>
                  </div>
                </div>
              </template>

            </div>
            <div class="text-center p-2" v-if="party.active_tab === 'emails'">
              <button class="btn custom-email-btn" @click="redirectToEmailSettings">
                GO TO EMAIL
              </button> </div>
          </div>
      </div>
    </div>
    <div class="modal fade" id="relatedPartyModal" tabindex="-1" aria-labelledby="relatedPartyModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="exampleModalLabel">Add Related Party</h5>
            <button type="button" class="close"  ref="closeRelatedPartyModal" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="addRelatedParty">
              <div class="form-group">
                <label for="group" class="col-form-label">Party Name:</label>
                <input type="text" name="party" v-model="fields.party" id="group" class="form-control"
                       placeholder="Party Name">
                <div v-if="errors.party">
                  <span class="text-danger font-weight-bold">{{ errors.party[0] }}</span>
                </div>
              </div>
              <div class="form-group">
                <label for="group" class="col-form-label">Code:</label>
                <input type="text" name="code" v-model="fields.code" id="group" class="form-control" placeholder="Code">
                <div v-if="errors.code">
                  <span class="text-danger font-weight-bold">{{ errors.code[0] }}</span>
                </div>
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-success btn-sm">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="relatedPartyUpdateModal" tabindex="-1" aria-labelledby="relatedPartyUpdateModalLabel"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold"  id="exampleModalLabel">Update Related Party</h5>
            <button type="button" class="close" ref="closeUpdateRelatedPartyModal" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="">
              <div>
                <div class="form-group">
                  <label for="group" class="col-form-label">Party Name:</label>
                  <input type="text" name="party" v-model="fields.party" id="group" class="form-control"
                         placeholder="Party Name">
                  <div v-if="errors.party">
                    <span class="text-danger font-weight-bold">{{ errors.party[0] }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="group" class="col-form-label">Code:</label>
                  <input type="text" name="code" v-model="fields.code" id="group" class="form-control"
                         placeholder="Code">
                  <div v-if="errors.code">
                    <span class="text-danger font-weight-bold">{{ errors.code[0] }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2">
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <button :class="[activeTab === 'vessels' ? 'active' : '']" class="main-tabs nav-link text-uppercase font-weight-bold" data-toggle="pill" type="button" role="tab" @click="activeTab = 'vessels'">Vessels</button>
                      <button :class="[activeTab === 'emails' ? 'active' : '']" class="main-tabs nav-link text-uppercase font-weight-bold" data-toggle="pill" type="button" role="tab" @click="activeTab = 'emails'">Emails</button>
                    </div>
                  </nav>
                </div>
                <template v-if="activeTab === 'vessels'">
                  <div class="col-3" v-for="vessel in vesselKeys">
                    <input type="checkbox" class="eldest-sister"
                           v-model="fields.vessels"
                           :value="vessel.id">
                    {{ vessel.name.toUpperCase() }}
                  </div>
                </template>
                <template v-else>
                  <div class="col-6" v-for="email in emailKeys">
                    <input type="checkbox" class="eldest-sister"
                           v-model="fields.emails"
                           :value="email.id">
                    {{ email.email_address }}
                  </div>
                </template>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="submit"
                    class="btn btn-primary btn-sm"
                    @click="updateRelatedParty"
                    :disabled="selectedHasChanges === false"
            >Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RelatedPartyService} from "@/services/RelatedPartyService";
import {AlertService} from "@/services/AlertService";

export default {
  name: "SettingsRelatedParty",
  data() {
    return {
      errors: {},
      fields: {
        party: '',
        code: ''
      },
      activeTab : 'vessels'
    }
  },
  computed: {
    ...mapGetters([
      'relatedPartyLists',
      'vesselKeys',
    ]),
    ...mapGetters('EmailModule',[
      'emailKeys'
    ]),
    selectedHasChanges() {
      const currentRelatedPartyList = this.relatedPartyLists.filter(party => party.id === this.fields.id);
      if (this.activeTab === 'vessels') {
        const editedVesselIds = this.fields.vessels;
        const currentRelatedPartyListVesselIds = currentRelatedPartyList[0]?.vessels.map(vessel => vessel.vessel_id) ?? []
        return editedVesselIds?.length !== currentRelatedPartyListVesselIds?.length ||
          [...editedVesselIds].sort().join() !== [...currentRelatedPartyListVesselIds].sort().join();
      } else if (this.activeTab === 'emails') {
        const editedEmailIds = this.fields.emails;
        const currentRelatedPartyListEmailIds = currentRelatedPartyList[0]?.emails.map(email => email?.email_id) ?? []
        return editedEmailIds?.length !== currentRelatedPartyListEmailIds?.length ||
          [...editedEmailIds].sort().join() !== [...currentRelatedPartyListEmailIds].sort().join();
      }
    }
  },
  methods: {
    ...mapActions([
      'getRelatedPartiesList',
      'getVesselKeys',
    ]),
    ...mapActions('EmailModule', [
      'getEmailKeys'
    ]),

    async addRelatedParty() {
      if (await AlertService.confirmCreateAlert('Do you want to add new related party ?')) {
        const response = await RelatedPartyService.addRelatedParty(this.fields);
        if (response.errors) {
          this.errors = response.errors
        } else {
          AlertService.successAlert('Related Party has been added successfully', 'Add Related Party')
          this.$refs.closeRelatedPartyModal.click()
          await this.getRelatedPartiesList()
        }
      }
    },
    resetForm() {
      this.fields = {
        party: '',
        code: ''
      }
      this.errors = {}
    },

    setForm(relatedParty) {
      this.resetForm();
      this.fields = {
        id: relatedParty?.id ?? null,
        party: relatedParty?.party_name ?? '',
        code: relatedParty?.code ?? '',
        active_tab: relatedParty?.active_tab ?? '',
        vessels: [...new Set (relatedParty?.vessels.map(vessel=>{
          return vessel.vessel_id
        }))],
        emails: [...new Set (relatedParty?.emails.map(email=>{
          return email.email_id
        }))]
      }
      this.activeTab = relatedParty.active_tab;
    },
    async updateRelatedParty(){
      let baseConfirmMessage = 'Do you want to add update related party';

      if (this.activeTab === 'vessels') {
        baseConfirmMessage += ' vessels?';
      } else {
        baseConfirmMessage += ' emails?';
      }
      if (await AlertService.confirmUpdateAlert(baseConfirmMessage)) {
        this.fields.vessels = this.fields.vessels.filter(vessel=> {
          return typeof vessel === 'number';
        })
        this.fields.emails = this.fields.emails.filter(email => {
          return typeof email === 'number';
        })

        this.fields.feature = this.activeTab
        const response = await RelatedPartyService.updateRelatedParty(this.fields)
        if (response.errors) {
          this.errors = response.errors
        } else {
          AlertService.successAlert('Related Party has been updated successfully', 'Update Related Party')
          await this.getRelatedPartiesList()

          this.relatedPartyLists.filter(item => item.id === this.fields.id)[0].active_tab = this.fields.active_tab
        }
      }
    },
    async deleteRelatedParty(relatedPartyId){
      if (await AlertService.confirmDeleteAlert('DELETE RELATED PARTY','Do you want to delete related party','Yes, delete it')) {
        const response = await RelatedPartyService.deleteRelatedParty({id:relatedPartyId})
        if(!response.errors) {
          AlertService.successAlert('Related Party has been updated successfully', 'Update Related Party')
          await this.getRelatedPartiesList()
        }
      }
    },
    async redirectToEmailSettings() {
      const route= this.$router.resolve(
        {
          name: 'SettingEmails',
        },
      )
      window.open(route.href,'_blank')
    }

  },
  created() {
    this.getRelatedPartiesList();
    this.getVesselKeys();
    this.getEmailKeys();
  },
}
</script>

<style scoped>
.nav-tabs .nav-link.active {
  color: #d3313c !important;
}

.custom-email-btn {
  border: 4px solid #4064A2;   /* Blue border */
  border-radius: 50px;         /* Pill shape */
  background-color: #ffffff;   /* White background */
  color: black;               /* Blue text */
  font-weight: 300;
  padding: 4px 15px;
  font-size: 10px;
}

.custom-email-btn:hover {
  background-color: #2f49d1;
  color: #ffffff;
}

</style>
